import { SearchBoxModel } from "./../../models/search-box";
import {backboneViewProperties} from "../../../decorators/backbone-properties";
import Marionette from "../../../shared/marionette-mustache";
import {AdvancedSearchFilterModel} from "../../../search/models/advanced-search-filter";

const template = require<string>("../../../search/views/advanced-search/checkbox-filter.html");

const dom = {
    ADVANCED_SEARCH_FILTERS: ".checkbox-filter",
    FILTER_INFO: ".search-filter-info"
};

@backboneViewProperties({
    template
})
export class AdvancedSearchFilterView extends Marionette.ItemView<AdvancedSearchFilterModel> {

    constructor(options?) {
        super(options);
        this.setupModelListeners();
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click " + dom.ADVANCED_SEARCH_FILTERS] = (e) => this.checkboxClicked(e);
        return events;
    }

    public checkboxClicked(e: JQueryEventObject) {
        const $checkbox = $(e.currentTarget);
        const checked = $checkbox.prop("checked");
        this.model.Included = checked;
    }

    public onShow() {
        this.setupPopover();
        this.enabledChanged(this.model, this.model.Enabled); // Do this one first as it impacts included changed
        this.includedChanged(this.model, this.model.Included);
    }

    private setupModelListeners(): void {
        this.listenTo(this.model, "change:Included", this.includedChanged);
        this.listenTo(this.model, "change:Enabled", this.enabledChanged);
    }

    private setupPopover() {

        const $icon = this.$(dom.FILTER_INFO);

        $icon.popover({
            container: "#application-container",
            viewport: "#application-container",
            placement: "left",
            html: true,
            trigger: "hover",
            title: this.model.DisplayName,
            content: () => this.getPopoverContent()
        });

    }

    private getPopoverContent() {

        const message = this.model.Subscribed ?
            "<span class='subscription-message positive'>You have a subscription to this product</span>" :
            (this.model.SearchWithSubscription ?
                "<span class='subscription-message negative'>You don't have a full text subscription to this product. This option is disabled whilst searching within your subscription.</span>" :
                "<span class='subscription-message negative'>You don't have a full text subscription to this product, but you can still search for citation information.</span>");

        const val = `<em>${this.model.Coverage}</em><br /><br /> ${this.model.Description}<br /><br />${message}`;

        return val;
    }

    private includedChanged(model: AdvancedSearchFilterModel, included: boolean): void {
        const $filter = $(`[id="filter-${this.model.DisplayName}"]`);
        $filter.prop("checked", included);
        if (this.model.AdvancedSearch) {
            this.model.AdvancedSearch.trigger("FilterChanged");
        }
    }

    private enabledChanged(model: AdvancedSearchFilterModel, enabled: boolean): void {
        const $filter = $(`[id="filter-${this.model.DisplayName}"]`);

        if (this.model.SearchWithSubscription) {
            if (!this.model.Subscribed) {
                $filter.parent().addClass("disabled").attr("title", "You are not subscribed to this series");
                $filter.attr("disabled", "true").prop("checked", false);
            } else {
                $filter.parent().addClass("disabled").attr("title", "You are searching with your subscription");
                $filter.attr("disabled", "true").prop("checked", true);
            }
        } else {
            if (enabled) {
                $filter.parent().removeClass("disabled").attr("title", "");
                $filter.removeAttr("disabled").prop("checked", true);
            } else {
                $filter.parent().addClass("disabled").attr("title", "This series is outside your jurisdiction settings");
                $filter.attr("disabled", "true").prop("checked", false);
            }
        }
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/advanced-search/advanced-search-filter.ts